import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { Stack } from "@mui-wrapper";
const AVATAR_SIZE = 40;

/**
 * Renders a skeleton/loading placeholder for a member list item card.
 * Displays animated skeleton elements in the same layout as ListItemCardMobile.
 *
 * @returns Skeleton placeholder with circular avatar and text lines
 */
export function SkeletonMemberListItemCard() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      flexDirection: "row",
      gap: 1,
      p: 1,
      alignItems: "center"
    };
    t1 = <Skeleton variant="circular" width={AVATAR_SIZE} height={AVATAR_SIZE} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Stack sx={t0}>{t1}<Stack sx={{
        flex: 1,
        minWidth: 0,
        gap: 0.5
      }}><Skeleton width="60%" height={16} /><Skeleton width="40%" height={14} /><Skeleton width="50%" height={14} /></Stack></Stack>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}